export const SurveyWithParamsState = {
	title: 'Survey Questions',
	url: '/survey/:consultationId',
	template: '<survey-page></survey-page>',
	params: {
		consultationId: {
			type: 'path',
			squash: true,
		},
	},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "surveyPageMod" */
			'@Containers/builder-survey-page/survey-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
	resolve: [
		{
			token: 'stateStatus',
			policy: {when: 'EAGER'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (ResolveSvc, trans) =>
				ResolveSvc.validateConsultationPrivate({status: 'draft', ...trans.params()}).catch(state =>
					trans.router.stateService.go(state.name, state.params)
				),
		},
	],
};
